import { Typography, Chip, IconButton } from "@mui/material";
import { styled, Box } from "@mui/system";
import theme from "../../../theme";

export const OrderContainer = styled(Box)`
  background: white;
  border: 1px solid ${theme.palette.grey[200]};
  border-radius: 6px;
  padding: 12px;
`;

export const OrderHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
`;

export const OrderId = styled(Typography)`
  font-weight: 500;
  color: ${theme.palette.text.primary};
  line-height: 1.3;
`;

export const PriorityContainer = styled(Box)`
  margin-bottom: 4px;
`;

export const StatusChip = styled(Chip)`
  font-size: 11px;
  height: 20px;
  font-weight: 500;
`;

export const Label = styled(Typography)`
  font-size: 14px;
  color: ${theme.palette.grey[700]};
  margin-right: 10px;
`;

export const OrderIdContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CopyIconButton = styled(IconButton)`
  padding: 4px;
  color: ${theme.palette.grey[500]};

  &:hover {
    color: ${theme.palette.primary.main};
    background-color: ${theme.palette.grey[100]};
  }

  & .MuiSvgIcon-root {
    font-size: 16px;
  }
`;
